import {Action} from 'react-fetching-library';
import {
    Auth0TokenValidateRequest, Auth0User,
    UserAppCreateFromResponse,
    UserAppFromAdminResponse,
    UserAppKeysResponse, UserAuth0Response,
    UserListFroAdminResponse,
    UserListFroMigrationResponse,
    UserResetPasswordRequest,
    UsersForMigrationRequest
} from './UsersDomain';
import {ServicesUrl} from '../../Config/UrlRuotes';
import {GetToken, MessageResponse} from '../Domain';
import {LoginActionResponse, UserApp} from '../../Context/AuthProvider/AuthProviderActions';

export const getUsersForMigrations:()=>Action<UserListFroMigrationResponse> = () => {
    const urlRequest = `${ServicesUrl.users}/migrations`;

    return {
        method: 'GET',
        endpoint: urlRequest,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const getUsersList:()=>Action<UserListFroAdminResponse> = () => {
    return {
        method: 'GET',
        endpoint: ServicesUrl.users,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const getUserById:(userID: number)=>Action<UserAppFromAdminResponse> = (userID) => {
    return {
        method: 'GET',
        endpoint: `${ServicesUrl.users}/${ userID }`,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const migrateUsers:(data:UsersForMigrationRequest)=>Action<MessageResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/migrations`;

    return {
        method: 'POST',
        endpoint: urlRequest,
        body: data.users,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const resetPassword:(data:UserResetPasswordRequest)=>Action<MessageResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/request_pass`;

    return {
        method: 'POST',
        endpoint: urlRequest,
        body: data,
    };
};

export const blockUser:(data:UserApp)=>Action<MessageResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${data.id}/block`;

    return {
        method: 'PUT',
        endpoint: urlRequest,
        body: data,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const unblockUser:(data:{id:number, ids:number, clave:string})=>Action<UserAppFromAdminResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${data.id}`;

    return {
        method: 'PUT',
        endpoint: urlRequest,
        body: data,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const decodeAuth0Token:(data:Auth0TokenValidateRequest)=>Action<LoginActionResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/decodetoken`;

    return {
        method: 'POST',
        endpoint: urlRequest,
        body: data,
    };
};

export const updateUser:(data:UserApp)=>Action<UserAppFromAdminResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${data.id}`;

    return {
        method: 'PUT',
        endpoint: urlRequest,
        body: data,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const createUser:(data:UserApp)=>Action<UserAppCreateFromResponse> = (data) => {
    return {
        method: 'POST',
        endpoint: ServicesUrl.users,
        body: data,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const getUserKeys:()=>Action<UserAppKeysResponse> = () => {
    const urlRequest = `${ServicesUrl.users}-keys`;

    return {
        method: 'GET',
        endpoint: urlRequest,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};


export const getGlobalUser:(data:{id: string})=>Action<UserAuth0Response> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${ data.id }/global`;

    return {
        method: 'GET',
        endpoint: urlRequest,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const updateGlobalUser:(data: {user:Auth0User, id: string })=>Action<MessageResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${ data.id }/global`;

    return {
        method: 'PUT',
        endpoint: urlRequest,
        body: data.user,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const uploadAvatar: (data:{userId: number, imageBlob: Blob}) => Action<UserAppFromAdminResponse> = (data) => {
    const urlRequest = `${ServicesUrl.users}/${data.userId}/avatar`;
    const formData = new FormData();
    formData.append('avatar', data.imageBlob, 'avatar.jpg');

    return {
        method: 'PUT',
        endpoint: urlRequest,
        body: formData,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export const resetAvatar: (userId: number) => Action<UserAppFromAdminResponse> = (userId) => {
    const urlRequest = `${ServicesUrl.users}/${userId}/avatar`;

    return {
        method: 'GET',
        endpoint: urlRequest,
        headers: {
            'Authorization-Token': GetToken()
        }
    };
};

export function getNewUser() : UserApp {
    return {
        id: 0,
        ids: 0,
        clave: '',
        first_name: '',
        last_name: '',
        full_name: '',
        email: '',
        mail_validado: false,
        rol: '',
        telephone: '',
        is_admin: false
    };
}
